module.exports = __webpack_public_path__ + "images/application/i-warning-orange-80a139cf.svg";